import { lazyLoad } from '../../utils/loadable';
export var SupportPage = lazyLoad(function () { return import('./Support'); }, function (module) { return module.Support; });
export var MakeAComplaintPage = lazyLoad(function () { return import('./MakeAComplaint'); }, function (module) { return module.MakeAComplaint; });
export var CreateAFaultPage = lazyLoad(function () { return import('./ReportAFault'); }, function (module) { return module.ReportAFault; });
